
const initGridFromSession = () => {
    const savedCols = sessionStorage.getItem('wizzyGridCols') || '4'; // default = 4
    const selector = savedCols == 2 ? '.wizzy-small-grid' : '.wizzy-large-grid';

    updateGrid(savedCols, selector);
};

 document.addEventListener('click', function (e) {
        if (!e.target.closest('.product-quick-add')) return;
        const el = document.querySelector('.wizzy-autocomplete-wrapper');
        if (el) {
            setTimeout(() => {
            el.style.opacity = '0';
            el.style.zIndex = '0';
            }, 500); // 1 second delay
        }
        });

const updateGrid = (cols, activeSelector) => {
    // Update columns everywhere
    document.querySelectorAll('.wizzy-search-results .main-collection--grid')
        .forEach(el => el.setAttribute('data-columns', cols));

    // Reset all grid buttons
    document.querySelectorAll('.wizzy-small-grid, .wizzy-large-grid')
        .forEach(btn => btn.setAttribute('data-active', 'false'));

    // Set active on current
    document.querySelector(activeSelector)?.setAttribute('data-active', 'true');

    // Optional: persist
    sessionStorage.setItem('wizzyGridCols', cols);
};
window.onWizzyScriptLoaded = function() {
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main_content'];
        window.wizzyConfig.filters.configs.layout = 'v1';
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
        window.wizzyConfig.store.currency.symbol = 'DHS.\u00A0'
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main_content'];
        window.wizzyConfig.filters.configs.layout = 'v1';
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
        window.wizzyConfig.store.currency.symbol = 'DHS.\u00A0'

        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
        data.facets.forEach((facet) => {
            // console.log(facet);
            if (facet.key == 'brands')
                facet.key = "product_vendor";
            // console.log(facet);

        })
        document.querySelector('.search--cancel')?.click();
        document.querySelectorAll('.shopify-section.section--image-with-text')?.forEach(el => el.style.opacity = '0');
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
        initGridFromSession();
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {


        // Event bindings
        document.querySelector('.wizzy-small-grid')?.addEventListener('click', () => {
            updateGrid(2, '.wizzy-small-grid');
        });

        document.querySelector('.wizzy-large-grid')?.addEventListener('click', () => {
            updateGrid(4, '.wizzy-large-grid');
        });
        initGridFromSession();

        // Apply button → trigger .wizzy-filters-bg
        document.querySelector('button.filter--button.wizzy-apply-btn')?.addEventListener('click', () => {
            document.querySelector('.wizzy-filters-bg')?.click();
        });

        // Clear button → trigger a.wizzy-filters-clear-all
        document.querySelector('button.filter--button.wizzy-clear-btn')?.addEventListener('click', () => {
            document.querySelector('a.wizzy-filters-clear-all')?.click();
        });

        document.querySelector('.wizzy-navigation--active-clear')?.addEventListener('click', () => {
            document.querySelector('a.wizzy-filters-clear-all')?.click();
        });
        return data;
    })
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(data) {
        data?.forEach(product => {
            product?.attributes?.forEach(atr => {
                if (atr?.id === "product_handle") {
                    product.handle = atr?.values?.[0]?.value?.[0];
                }
            });
            product.isBestSeller = false
            product.isNewIn = false;
            product?.categories?.some(cat => {
                if (cat?.id === "bestsellers") {
                    product.isBestSeller = true;
                    return true; // stops loop
                }
                if (cat?.id === "new-in") {
                    product.isNewIn = true;
                    return true; // stops loop
                }
                 if (cat?.id === "add-a-pair-and-save") {
                    product.isDiscountTag = true;
                    return true; // stops loop
                }
                return false;
            });
        });

        return data;
    }, 1);


}